import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesEnum } from '../../../../enums/routes.enum';
import { UserRoleEnum } from '../../../../enums/user.enums';
import { StaticComponentType } from '../../../../interfaces/base-modal-content.interface';
import { ModalService } from '../../../../services/modal.service';
import { AuthStore } from '../../../../stores/auth.store';
import { CardHeaderComponent } from '../../../atoms/card-header/card-header.component';
import { CardComponent } from '../../../atoms/card/card/card.component';
import { IconComponent } from '../../../atoms/icon/icon.component';
import { MainLayoutComponent } from '../../../organisms/main-layout/main-layout.component';
import { ModalChangePasswordComponent } from '../../../organisms/modal/modal-change-password/modal-change-password.component';
import { ModalChangeUserComponent } from '../../../organisms/modal/modal-change-user/modal-change-user.component';
import { ModalCheckInExportComponent } from '../../../organisms/modal/modal-check-in-export/modal-check-in-export.component';
import { ModalDeleteUserComponent } from '../../../organisms/modal/modal-delete-user/modal-delete-user.component';
import { ModalLeaderBoardComponent } from '../../../organisms/modal/modal-leader-board/modal-leader-board.component';

@Component({
  selector: 'app-profile',
  imports: [CardComponent, MainLayoutComponent, CardHeaderComponent, IconComponent],
  templateUrl: './profile.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './profile.component.scss',
})
export class ProfileComponent {
  private readonly authStore = inject(AuthStore);
  private readonly modalService = inject(ModalService);
  private readonly router = inject(Router);

  readonly ModalCheckInExportComponent = ModalCheckInExportComponent;
  readonly ModalLeaderBoardComponent = ModalLeaderBoardComponent;
  readonly ModalChangeUserComponent = ModalChangeUserComponent;
  readonly ModalChangePasswordComponent = ModalChangePasswordComponent;
  readonly ModalDeleteUserComponent = ModalDeleteUserComponent;

  readonly isCoach = computed(() => this.authStore.userRole() === UserRoleEnum.COACH);

  public openModal(component: StaticComponentType<any>): void {
    this.modalService.openOverlayWithConfig(component);
  }

  public goToPrivacyPolicy(): void {
    this.router.navigateByUrl(RoutesEnum.COMMON_PRIVACY_POLICY);
  }

  public logout(): void {
    this.authStore.logout().subscribe();
  }
}
